import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {JourneyRoutingModule} from './journey-routing.module';
import {JourneyPage} from './journey/journey-page.component';
import {JourneyDiaryPage} from './journey-diary/journey-diary-page.component';
import {LearningJourneyListTemplateComponent} from './components/list-template/list-template.component';
import {LearningJourneyProgrammTemplateComponent} from './components/programm-template/programm-template.component';
import {LearningJourneyTextTemplateComponent} from './components/text-template/text-template.component';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {LearningJourneySkeletonTemplateComponent} from './components/skeleton-template/skeleton-template.component';
import {LearningJourneyListTemplateCheckboxComponent} from './components/list-template-checkbox/list-template-checkbox.component';
import {LearningJourneyListTemplateTextareaComponent} from './components/list-template-textarea/list-template-textarea.component';
import {
  LearningJourneyListTemplateFeedbackListComponent
} from './components/list-template-feedback-list/list-template-feedback-list.component';
import {LearningJourneyListTemplateFinancialComponent} from './components/list-template-financial/list-template-financial.component';
import {LearningJourneyListTemplateWebinarComponent} from './components/list-template-webinar/list-template-webinar.component';
import {LearningJourneyListTemplateUploadComponent} from './components/list-template-upload/list-template-upload.component';
import {LearningJourneyListTemplateAttendanceComponent} from './components/list-template-attendance/list-template-attendance.component';
import {
  LearningJourneyListTemplateTrainerCommentsComponent
} from './components/list-template-trainer-comments/list-template-trainer-comments.component';
import {LearningJourneyListTemplateEmbedVideoComponent} from './components/list-template-embed-video/list-template-embed-video.component';
import {ListDropdownComponent} from './components/list-dropdown/list-dropdown.component';
import {
  LearningJourneyListTemplateCourseTitleComponent
} from './components/list-template-course-title/list-template-course-title.component';
import {
  LearningJourneyListTemplateCourseOverviewComponent
} from './components/list-template-course-overview/list-template-course-overview.component';
import {PipesModule} from '../../pipes/pipes.module';
import {LearningJourneyListTemplateHtmlComponent} from './components/list-template-html/list-template-html.component';
import {TaskPage} from './task/task.page';
import {
  LearningJourneyListTemplateFeedbackMultiselectComponent
} from './components/list-template-feedback-multiselect/list-template-feedback-multiselect.component';
import {
  LearningJourneyListTemplateFeedbackProgressComponent
} from './components/list-template-feedback-progress/list-template-feedback-progress.component';
import {JourneyStagePage} from './journey-stage/journey-stage-page.component';
import {LearningJourneyListTemplateInteractionComponent} from './components/list-template-interaction/list-template-interaction.component';
import {
  LearningJourneyListTemplateInteractionCardComponent
} from './components/list-template-interaction-card/list-template-interaction-card.component';
import {LearningJourneyListTemplateAICoachComponent} from './components/list-template-ai-coach/list-template-ai-coach.component';
import {
  LearningJourneyListTemplateInteractionEmbeddedComponent
} from './components/list-template-interaction-embedded/list-template-interaction-embedded.component';
import {ConferenceComponentsModule} from '../conference/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    JourneyRoutingModule,
    ComponentsModule,
    PipesModule,
    TranslateModule.forChild(),
    ConferenceComponentsModule
  ],
  declarations: [
    TaskPage,
    JourneyPage,
    JourneyDiaryPage,
    JourneyStagePage,
    ListDropdownComponent,
    LearningJourneySkeletonTemplateComponent,
    LearningJourneyListTemplateComponent,
    LearningJourneyProgrammTemplateComponent,
    LearningJourneyTextTemplateComponent,
    LearningJourneyListTemplateCheckboxComponent,
    LearningJourneyListTemplateCourseTitleComponent,
    LearningJourneyListTemplateCourseOverviewComponent,
    LearningJourneyListTemplateFeedbackListComponent,
    LearningJourneyListTemplateFeedbackMultiselectComponent,
    LearningJourneyListTemplateFeedbackProgressComponent,
    LearningJourneyListTemplateAICoachComponent,
    LearningJourneyListTemplateHtmlComponent,
    LearningJourneyListTemplateTextareaComponent,
    LearningJourneyListTemplateFinancialComponent,
    LearningJourneyListTemplateUploadComponent,
    LearningJourneyListTemplateWebinarComponent,
    LearningJourneyListTemplateAttendanceComponent,
    LearningJourneyListTemplateTrainerCommentsComponent,
    LearningJourneyListTemplateEmbedVideoComponent,
    LearningJourneyListTemplateInteractionComponent,
    LearningJourneyListTemplateInteractionCardComponent,
    LearningJourneyListTemplateInteractionEmbeddedComponent
  ],
  exports: [
    ListDropdownComponent,
    LearningJourneySkeletonTemplateComponent,
    LearningJourneyListTemplateComponent,
    LearningJourneyProgrammTemplateComponent,
    LearningJourneyTextTemplateComponent,
    LearningJourneyListTemplateCheckboxComponent,
    LearningJourneyListTemplateCourseTitleComponent,
    LearningJourneyListTemplateCourseOverviewComponent,
    LearningJourneyListTemplateFeedbackListComponent,
    LearningJourneyListTemplateFeedbackMultiselectComponent,
    LearningJourneyListTemplateFeedbackProgressComponent,
    LearningJourneyListTemplateAICoachComponent,
    LearningJourneyListTemplateHtmlComponent,
    LearningJourneyListTemplateTextareaComponent,
    LearningJourneyListTemplateFinancialComponent,
    LearningJourneyListTemplateUploadComponent,
    LearningJourneyListTemplateWebinarComponent,
    LearningJourneyListTemplateAttendanceComponent,
    LearningJourneyListTemplateTrainerCommentsComponent,
    LearningJourneyListTemplateEmbedVideoComponent,
    LearningJourneyListTemplateInteractionComponent,
    LearningJourneyListTemplateInteractionCardComponent,
    LearningJourneyListTemplateInteractionEmbeddedComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class JourneyModule {
}
